import React, { useState } from "react";

import { css } from "@emotion/react";
import styled from "@emotion/styled";

import Checkbox from "../../../../../shared/forms/Checkbox";
import FormError from "../../../../../shared/forms/FormError";
import PdfModal from "../../../../../shared/PdfModal";
import { TermsOfServiceModalActivator } from "../../../../Shop/Checkout/StepSummary";
import useAgbStore from "./store";

const CheckboxRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-top: 20px;

    a {
        display: inline-block;
    }
`;

const Label = styled.div`
    flex-grow: 1;
`;

const defaultModalData = {
    documentPath: "",
    title: "",
    isVisible: false,
};

const Agb = () => {
    const [agbChecked, setAgbChecked, hasErrorAt] = useAgbStore((state) => [
        state.agbChecked,
        state.setAgbChecked,
        state.hasErrorAt,
    ]);
    const [modalData, setModalData] = useState(defaultModalData);

    const showTermsModal = (event, documentPath, title) => {
        event.preventDefault();
        setModalData({
            documentPath: documentPath,
            title: title,
            isVisible: true,
        });
    };

    return (
        <React.Fragment>
            <PdfModal
                title={modalData.title}
                pdfPath={modalData.documentPath}
                pdfScale={1.25}
                isVisible={modalData.isVisible}
                onClose={() => setModalData(defaultModalData)}
            />
            <CheckboxRow>
                <div>
                    <Checkbox
                        checked={agbChecked}
                        onClick={() => {
                            setAgbChecked(!agbChecked);
                        }}
                        css={css`
                            margin-top: 7px;
                            margin-right: 15px;
                        `}
                    />
                </div>
                <Label>
                    <span>
                        Ich erkenne die{" "}
                        <TermsOfServiceModalActivator
                            onClick={(event) =>
                                showTermsModal(
                                    event,
                                    "/img/Hoyer_AGB_Unternehmensgruppe.pdf",
                                    "AGB"
                                )
                            }
                        >
                            AGB
                        </TermsOfServiceModalActivator>{" "}
                        an und habe die{" "}
                        <TermsOfServiceModalActivator
                            onClick={(event) =>
                                showTermsModal(
                                    event,
                                    "/img/11.RET-XXX.FB001_Widerrufsbelehrung.pdf",
                                    "Widerrufsbelehrung"
                                )
                            }
                        >
                            Widerrufsbelehrung
                        </TermsOfServiceModalActivator>{" "}
                        gelesen.
                    </span>
                </Label>
            </CheckboxRow>
            {hasErrorAt("agb") && (
                <FormError message="Um die Bestellung abzuschließen, muss den AGB zugestimmt werden." />
            )}
        </React.Fragment>
    );
};

export default Agb;
